module.exports = __webpack_public_path__ + "6120ee27de8f50bf34551581a9a4c14c.svg";